import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { ShowBuildingDocumentsCommandHandler } from './show-building-documents-command-handler.service';
import { LinkBuildingDocumentCommandHandler } from './link-building-document-command-handler.service';
import { buildingCommand } from '../../command/building.command';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { MoveToPropertyCommandHandler } from './move-to-property-command-handler.service';
import { BuildingExportCommandHandler } from './building-export-command-handler.service';

@Injectable()
export class BuildingCommandHandlerResolver extends StandardCommandHandlerResolver {
  constructor(
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    exportHandler: BuildingExportCommandHandler,
    moveToPropertyHandler: MoveToPropertyCommandHandler
  ) {
    super(deleteHandler, editHandler);
    this.addHandler(buildingCommand.export, exportHandler);
    this.addHandler(buildingCommand.moveToProperty, moveToPropertyHandler);
  }
}
